import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["onClick"];
import useMessageCompanyUser from "../../composables/message/useMessageCompanyUser";
import ModalWindow from "../ModalWindow.vue";
import { onMounted, watch, ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'MessageCompanyUserSelecterModal',
    props: {
        companyId: {},
        fromUserId: {}
    },
    emits: ["selectCompanyUser"],
    setup(__props, { emit: __emit }) {
        const { messageCompanyUsers, fetchMessageCompanyUsers } = useMessageCompanyUser();
        const props = __props;
        onMounted(() => {
            fetchMessageCompanyUsers(props.companyId, props.fromUserId);
        });
        watch(() => props.companyId, () => {
            fetchMessageCompanyUsers(props.companyId, props.fromUserId);
        });
        watch(() => props.companyId, () => {
            fetchMessageCompanyUsers(props.companyId, props.fromUserId);
        });
        watch(() => props.fromUserId, () => {
            fetchMessageCompanyUsers(props.companyId, props.fromUserId);
        });
        const isVisible = ref(false);
        const close = () => {
            isVisible.value = false;
        };
        const truncateString = (str) => {
            const maxLength = 20;
            if (str.length > maxLength) {
                return str.substring(0, maxLength) + "...";
            }
            else {
                return str;
            }
        };
        const emit = __emit;
        const selectCompanyUser = (userId) => {
            emit("selectCompanyUser", userId);
            close();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ModalWindow, {
                "is-visible": "isVisible",
                onClose: close,
                index: -1
            }, {
                default: _withCtx(() => [
                    _createElementVNode("table", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messageCompanyUsers), (user, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", null, _toDisplayString(user.name), 1),
                                _createElementVNode("td", null, _toDisplayString(user.messageCount), 1),
                                _createElementVNode("td", null, _toDisplayString(truncateString(user.latestMessage)), 1),
                                _createElementVNode("td", null, _toDisplayString(user.latestMessageSentAt), 1),
                                _createElementVNode("td", null, [
                                    _createElementVNode("button", {
                                        onClick: ($event) => (selectCompanyUser(user.userId))
                                    }, "見る", 8, _hoisted_1)
                                ])
                            ]));
                        }), 128))
                    ])
                ]),
                _: 1
            }));
        };
    }
});
